/* Search & research (API: api/src/modules/search/README.md and api/src/modules/research/README.md):
   cited answers with scope, quality labels and claim checks, URL reading, live cards, Discover, deep
   research (plan, progress, report) and wide research (table). Exports CitedAnswer for chat.
   Merged into Ask (features/ask): hidden here, /search and /research redirect into Ask, and the screen in this
   folder is what Ask shows at /ask/search. */
import { lazy } from 'react';
import { Telescope } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'search',
  title: 'Search & research',
  short: 'Search',
  icon: Telescope,
  group: 'Work',
  route: '/search',
  order: 3,
  hidden: true,
  screen: lazy(() => import('../ask/AskRedirect.tsx')),
  capabilities: [
    'SEARCH-01', 'SEARCH-02', 'SEARCH-03', 'SEARCH-04', 'SEARCH-05', 'SEARCH-06', 'SEARCH-07', 'SEARCH-08', 'SEARCH-09',
    'RESEARCH-01', 'RESEARCH-02', 'RESEARCH-03',
  ],
});
